const location = (value, pageHandle) => ({
  value,
  label: value,
  ...(pageHandle ? { pageHandle } : {}),
});

const interest = (value, locations, label = value) => ({ value, label, locations });

const shared = {
  marquardt: location("The Marquardt - Watertown", "the-marquardt"),
  cesta: location("The Cesta - Fitchburg", "the-cesta"),
  lutheran: location(
    "Lutheran Homes and Health Services - Fond du Lac",
    "lutheran-homes-and-health-services",
  ),
  stElizabeth: location("St. Elizabeth - Janesville", "st-elizabeth"),
  stAnnes: location("St. Anne's - Milwaukee", "st-annes"),
  stDominic: location("St. Dominic Villa - Hazel Green", "st-dominic-villa"),
  menomoneeFalls: location(
    "LindenGrove Menomonee Falls",
    "lindengrove-menomonee-falls",
  ),
  waukesha: location("LindenGrove Waukesha", "lindengrove-waukesha"),
  mukwonago: location("LindenGrove Mukwonago", "lindengrove-mukwonago"),
  newBerlin: location("LindenGrove New Berlin", "lindengrove-new-berlin"),
  chaska: location("Auburn Homes & Services - Chaska", "chaska"),
  waconia: location("Auburn Homes & Services - Waconia", "waconia"),
  theAlee: location("The Alee, Fitchburg", "the-alee"),
};

const withLocations = (...values) =>
  values.map((value) =>
    typeof value === "string" ? location(value) : { ...value },
  );

export const publicLeadCaptureFallback = {
  interests: [
    interest("Independent Living", withLocations("Not Sure", shared.marquardt, shared.cesta)),
    interest(
      "Assisted Living / Memory Care",
      withLocations(
        "Not Sure",
        shared.marquardt,
        shared.lutheran,
        shared.stAnnes,
        shared.waukesha,
        shared.mukwonago,
        shared.newBerlin,
        shared.chaska,
        shared.waconia,
        shared.cesta,
      ),
    ),
    interest(
      "Skilled Nursing / Rehab",
      withLocations(
        "Not Sure",
        shared.marquardt,
        shared.lutheran,
        shared.stElizabeth,
        shared.stAnnes,
        shared.stDominic,
        shared.menomoneeFalls,
        shared.waukesha,
        shared.mukwonago,
        shared.newBerlin,
        shared.chaska,
        shared.waconia,
      ),
    ),
    interest("Giving", withLocations("Illuminus Foundation")),
    interest(
      "Career Opportunities",
      withLocations(
        "Not Sure",
        shared.marquardt,
        shared.lutheran,
        shared.stElizabeth,
        shared.stAnnes,
        shared.stDominic,
        "Illuminus",
        shared.menomoneeFalls,
        shared.waukesha,
        shared.mukwonago,
        shared.newBerlin,
        shared.chaska,
        shared.waconia,
        shared.cesta,
        "Park Hill, Watertown",
        "Trinity Terrace, Racine",
        "Lincoln Villas North, Racine",
        shared.theAlee,
        "Talheim Apartments, Chaska",
      ),
    ),
    interest(
      "Affordable Housing",
      withLocations(
        "Not Sure",
        "Park Hill, Watertown",
        "Trinity Terrace, Racine",
        "Lincoln Villas North, Racine",
        shared.theAlee,
        "Talheim Apartments, Chaska",
      ),
      "Affordable Housing (Income Eligibility Required)",
    ),
  ],
};
